export const slugify = (text) => text.toLowerCase().split(' ').join('-');
export const getElementFromHtmlString = (htmlString, selector) => {
    var _a;
    let textVal = null;
    let div = document.createElement('div');
    div.innerHTML = htmlString;
    textVal = (_a = div.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.innerHTML;
    return textVal;
};
// FIXME queste cose vanno fatte a backend, non qui
export const calculateDateforJP = (date) => {
    if (!date)
        return;
    const splitted = date.split('.');
    const year = splitted.pop();
    const days = splitted.shift();
    if (year.length == 4 && window.country == 'JP') {
        splitted.splice(0, 0, year);
        splitted.splice(2, 0, days);
        return splitted.join('.');
    }
    else {
        return date;
    }
};
export const validateEmail = (email) => {
    return /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/.test(email);
};
export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
export const getZeroPadNumber = (_number, digits = 2) => {
    return _number.toString().length >= digits ? _number.toString() : _number.toString().padStart(digits, '0');
};
// REF :: https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
export const useStringRgbContrast = (rgbCssString, dark = 'rgb(0,0,0)', light = 'rgb(255,255,255)') => {
    if (!rgbCssString)
        return dark;
    //parso la stringa RGB
    let rgb = rgbCssString.replace('rgb(', '').replace(')', '').split(',');
    if (rgb.length < 3)
        return dark;
    //trasformo rgb in srgb
    let srgb = rgb.map((n) => {
        let c = Number(n) / 255;
        if (c <= 0.04045)
            return c / 12.92;
        return Math.pow((c + 0.055) / 1.055, 2.4);
    });
    //calcolo la luminescenza
    const L = 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
    //calcolo se il colore di contrasto è light
    const useDark = L > Math.sqrt(1.05 * 0.05) - 0.05;
    // console.log(`%c${rgbCssString}`, `background-color: ${rgbCssString}; color: ${useDark ? '#000' : '#FFF'}; padding:4px; border: solid 1px red;`, L, srgb, rgb);
    //ritorno la stringa passata come parametro
    return useDark ? dark : light;
};
export const getRandomUUID = (prefix) => {
    var _a, _b;
    let uuid = ((_a = window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) && ((_b = window.crypto) === null || _b === void 0 ? void 0 : _b.randomUUID());
    if (!uuid)
        uuid = Math.random().toString(26);
    return `${prefix || ''}${uuid}`;
};
